import { allReleasingSteps } from "@modules/course/non-access/content/ReleaseSteps";
import CalendarTimeIcon from "@svg/product/CalendarTime";
import { useAccess } from "@templates/course/hooks/useAccess";
import { FC } from "react";

const RecordignProductSidebarFooter: FC = () => {
  const { courseData } = useAccess();
  const {
    product: { status },
  } = courseData;

  const activeStep = allReleasingSteps.find((f) => f.status === status) || null;
  return (
    <>
      <div className="flex items-center gap-3.5">
        <div className="flex items-center justify-center w-4 h-4 bg-fds-icon-accent rounded-full">
          <div className="animate-ping bg-fds-icon-accent w-4 h-4 absolute rounded-full" />
          <div className="animate-ping bg-fds-icon-accent w-3 h-3 absolute rounded-full" />
        </div>
        <p className="title-md-medium text-fds-secondary">
          {activeStep?.title || "ضبط آموزش"}
        </p>
      </div>
      <div className="flex flex-col w-full gap-2  py-2.5   px-4     bg-fds-canvas-primary rounded-8">
        <div className="flex gap-1.5  items-center">
          <CalendarTimeIcon className="text-fds-icon-secondary" />
          <p className="title-sm text-fds-primary">
            زمان تقریبی انتشار: ۳ تا ۶ ماه
          </p>
        </div>
        <p className="title-xsm text-fds-secondary">
          (برای ۹۰ درصد آموزش‌ها در این مرحله)
        </p>
      </div>
    </>
  );
};

export default RecordignProductSidebarFooter;
